import React from "react";
import { isMobile } from "react-device-detect";

import { default as ThreeDotsShared } from "@/shared/components/DropDown/ThreeDots";
import { ThreeDotsProps } from "@/shared/components/DropDown/ThreeDots.constants";

const ThreeDots = (props) => {
  return <ThreeDotsShared {...props} isMobile={isMobile} textMode={false} />;
};

ThreeDots.propTypes = ThreeDotsProps;

export default ThreeDots;
